import { httpServiceClient } from '@/infra/http'
import { NamingStrategy } from '@/infra/http/http-service-client/http-service-client-types'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import {
  UserContentDetailsQuery,
  UserContentDetailsResponse
} from './user-content-details-service-types'
import { formatUserContentDetails } from './user-content-details-service-utils'

const getUserContentUrl = () => makeApiUrl('/v2/user/content/product')

export const createUserContentDetailsService = (client = httpServiceClient) => ({
  async fetchUserContentDetails(id: number, query: UserContentDetailsQuery = {}) {
    const pathUrl = `${getUserContentUrl()}/${id}`

    const response = await client<UserContentDetailsResponse>({
      method: 'get',
      url: pathUrl,
      params: {
        toEnrollment: query.toEnrollment
      },
      paramsNamingStrategy: NamingStrategy.snakeCase
    })

    if (!response.body?.data) {
      throw new Error('User content details data not available')
    }

    return formatUserContentDetails(response.body.data as UserContentDetailsResponse)
  }
})

export const userContentDetailsService = createUserContentDetailsService()
